import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useRegisterMutation, {
  type IntentParams,
  type SubmitValues,
} from './queries/useRegisterMutation';
import type { UserRegistrationError } from '@/services/register.types.ts';

interface UseRegisterSubmitArgs {
  registrationToken: string;
  intentParams: IntentParams;
}

const useRegisterSubmit = ({
  registrationToken,
  intentParams,
}: UseRegisterSubmitArgs) => {
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = useState<string>();
  const clearErrors = () => setErrorMessage(undefined);

  const mutation = useRegisterMutation({
    registrationToken,
    intentParams,
    onError: (errorCode: UserRegistrationError) => {
      setErrorMessage(
        t('pageRegister.errorCreateAccount', { context: errorCode }),
      );
    },
  });

  const handleSubmitRegister = (values: SubmitValues) => {
    clearErrors();
    return mutation.mutate(values);
  };

  return {
    clearErrors,
    errorMessage,
    handleSubmitRegister,
    isSubmitting: mutation.isPending,
  };
};

export default useRegisterSubmit;
